"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var stats_graphic_svg_1 = __importDefault(require("@assets/components/home/statistics-graphic/stats-graphic.svg"));
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        root: {
            maxWidth: '100%',
        },
    });
});
var StatisticsGraphic = function () {
    var classes = useStyles();
    return (react_1.default.createElement("img", { className: classes.root, src: stats_graphic_svg_1.default, alt: "Statistics graphic", draggable: false }));
};
exports.default = StatisticsGraphic;
